<template>
  <div class="how-to-rent-step d-flex flex-column gap-md">
    <div class="d-flex flex-column gap-sm">
      <div
        v-for="({ title, text}, index) in steps"
        :key="title"
        class="d-flex align-items-center gap-xs">
        <h4 class="step-number mb-0 flex-shrink-0">
          {{ index + 1 }}
        </h4>
        <p>
          {{ text }}
        </p>
      </div>
    </div>
    <div class="details d-flex flex-column align-items-center gap-xxs p-xl pt-lg bg-white color-plum shadow-primary">
      <IconOrigamiDress/>
      <p class="text-center">
        <b v-if="unlimitedTrialActive">Surprise! You've Got Unlimited Swaps This Month!<br></b>
        <b v-else>Pro Tip: </b>
        <span>Swap out just one item or everything, and enjoy your styles until your next case arrives.</span>
      </p>
    </div>
  </div>
</template>

<script setup>
import { useUnlimitedTrialStore } from '@/stores/unlimitedTrial.js'
import IconOrigamiDress from '@shared/components/icons/IconOrigamiDress.vue'
import { storeToRefs } from 'pinia'

const steps = [
  {
    text: 'Select items and confirm your case',
  },
  {
    text: 'Wear them as long as you want',
  },
  {
    text: 'Swap when you want to switch it up',
  },
  {
    text: 'Send them back in the reusable bag—we\'ll handle the laundry',
  }
]

const { unlimitedTrialActive } = storeToRefs(useUnlimitedTrialStore())
</script>

<style lang="scss" scoped>
.how-to-rent-step {
  max-width: 325px;

  .details {
    border-radius: $sequin-border-radius;

    // Smaller margins on shorter screens like iPhone SE
    @media (max-height: 667px) {
      padding: $spacing-md !important;
      padding-top: $spacing-xs !important;
    }
  }
  .step-number {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background-color: $orchid;
    color: $white;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>